import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

import UserTableRow from './UserTableRow';

const UserTable = ({
	userList,
	onSelected
}) => {
	const users = userList.map((user) => {
		return (
			<UserTableRow key={user.userName} user={user} onSelected={onSelected}/>
		);
	});

	return (
		<div className="col-lg-12">
      <table className="table table-hover users-table">
        <thead>
          <tr>
            <th>{I18n.t('NAME')}</th>
            <th>{I18n.t('STATUS')}</th>
            <th/>
          </tr>
        </thead>
        <tbody>
          {users}
        </tbody>
      </table>
    </div>
	);
};

UserTable.propTypes = {
	onSelected: PropTypes.func.isRequired,
	userList: PropTypes.array.isRequired
};

export default UserTable;


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/UserTable.js
 **/